"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalForResult = void 0;
/**
 *  Return `true`:
 *      1. if `lhs === rhs`.
 *      2. if _lhs_ and _rhs_ is same kind, and they contain same value.
 *
 *  Otherwise, return `false`.
 *
 *  This function is designed for `Result<T, E>`.
 *  This function may return `true` if input values has same properties with `Result<T, E>`
 *  and their properties are same between _lhs_ and _rhs_.
 */
function equalForResult(lhs, rhs) {
    if (lhs === rhs) {
        return true;
    }
    if (lhs.ok !== rhs.ok) {
        return false;
    }
    var isEqual = lhs.val === rhs.val && lhs.err === rhs.err;
    return isEqual;
}
exports.equalForResult = equalForResult;
